'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListStyled = undefined;

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  alignItems: _propTypes2.default.oneOf(['top', 'center', 'bottom'])
};

var defaultProps = {
  alignItems: 'center'
};

var ALIGN_MAP = {
  top: 'flex-start',
  center: 'center',
  bottom: 'flex-end'
};

var align = function align(_ref) {
  var alignItems = _ref.alignItems;
  return 'align-items: ' + ALIGN_MAP[alignItems] + ';';
};

var ListStyled = exports.ListStyled = _styledComponents2.default.ol.withConfig({
  displayName: 'ListStyled'
})(['list-style-type:none;padding:0;margin:0;flex-grow:1;display:flex;', ''], align);

ListStyled.propTypes = propTypes;
ListStyled.defaultProps = defaultProps;


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-breadcrumbs/dist/styles/ListStyled.js
// module id = 557
// module chunks = 0